import api from './api';

export interface OverduePayment {
  id: number;
  student_course: number;
  student_name: string;
  student_fin: string;
  course_name: string;
  company_name: string;
  period_year: number;
  period_month: number;
  period_display: string;
  required_amount: string;
  paid_amount: string;
  debt_amount: string;
  remaining_amount: string;
  due_date: string;
  status: string;
  status_display: string;
  is_overdue: boolean;
  days_overdue: number;
  description?: string;
  created_at: string;
  updated_at: string;
}

export interface OverduePaymentStats {
  total_overdue: number;
  total_amount: string;
  critical_count: number;
  high_count: number;
  medium_count: number;
  low_count: number;
  by_priority: Record<string, { label: string; count: number }>;
  filter_date?: string; // YYYY-MM-DD format
}

export interface OverduePaymentFilters {
  search?: string;
  company?: string;
  days_overdue_min?: number;
  days_overdue_max?: number;
  filter_date?: string; // YYYY-MM-DD format
}

export interface OverduePaymentResponse {
  success: boolean;
  data?: OverduePayment[];
  message?: string;
}

export interface OverduePaymentStatsResponse {
  success: boolean;
  data?: OverduePaymentStats;
  message?: string;
}

export const overduePaymentAPI = {
  // Gecikmiş ödənişləri əldə et
  getOverduePayments: async (filters?: OverduePaymentFilters): Promise<OverduePaymentResponse> => {
    try {
      const params = new URLSearchParams();
      if (filters?.search) params.append('search', filters.search);
      if (filters?.company) params.append('company', filters.company);
      if (filters?.days_overdue_min) params.append('days_overdue_min', filters.days_overdue_min.toString());
      if (filters?.days_overdue_max) params.append('days_overdue_max', filters.days_overdue_max.toString());
      if (filters?.filter_date) params.append('filter_date', filters.filter_date);

      const response = await api.get(`/payments/overdue/?${params.toString()}`);
      return {
        success: true,
        data: response.data
      };
    } catch (error: any) {
      return {
        success: false,
        message: error.response?.data?.message || 'Gecikmiş ödənişlər yüklənmədi'
      };
    }
  },

  // Gecikmiş ödənişlər statistikaları
  getOverdueStatistics: async (filters?: OverduePaymentFilters): Promise<OverduePaymentStatsResponse> => {
    try {
      const params = new URLSearchParams();
      if (filters?.filter_date) params.append('filter_date', filters.filter_date);

      const response = await api.get(`/payments/overdue_statistics/?${params.toString()}`);
      return {
        success: true,
        data: response.data
      };
    } catch (error: any) {
      return {
        success: false,
        message: error.response?.data?.message || 'Statistikalar yüklənmədi'
      };
    }
  },

  // Ödənişi tam ödənilmiş kimi qeyd et
  markAsPaid: async (paymentId: number, amount: number, paymentMethod: string, paymentDate: string): Promise<{ success: boolean; message?: string }> => {
    try {
      const response = await api.post(`/payment-transactions/`, {
        payment: paymentId,
        amount: amount,
        payment_method: paymentMethod,
        payment_date: paymentDate,
        description: 'Gecikmiş ödəniş tamamlandı'
      });
      return {
        success: true,
        message: 'Ödəniş tamamlandı'
      };
    } catch (error: any) {
      return {
        success: false,
        message: error.response?.data?.message || 'Ödəniş tamamlanmadı'
      };
    }
  }
};